import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-marker-pin-01',
  imports: [],
  templateUrl: './marker-pin-01.html',
  styleUrl: './marker-pin-01.scss',
})
export class MarkerPin01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
